// import {ButtonType, ButtonWidget} from '@tableau/widgets';
import React from 'react';

import {SettingsSection} from '~src/settings/components/common/SettingsSection';
import {componentRegistryEntry} from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import {SitePrivateConnectSettingsForSiteAdminProps} from '~src/settings/privateconnect-settings/PrivateConnectSettingsCoordinator';
import {UserSettingsStyle} from '~src/userSettings/styles/UserSettingsStyle';

export interface IPrivateConnectConnection {
  privateConnectionName: string;
  description: string;
  region: string;
  vpcEndpointId: string;
  serviceName: string; // ISO 8601 format: YYYY-MM-DDThh:mm:ssZ
  status: string;
  actions: string;
}

export function PrivateConnectConnectionsSection(props: SitePrivateConnectSettingsForSiteAdminProps) {
  let fakeRow1: IPrivateConnectConnection = {
    privateConnectionName: 'private_connect_test',
    description: 'It connects to an enpoint service in dev account',
    region: 'us-west-2',
    vpcEndpointId: 'vpce-0510952601a024858',
    serviceName: '       com.amazonaws.vpce.ap-south-1.vpce-svc-090cc9338e1e1159e',
    status: 'Ready',
    actions: 'Provision'
  };

  let fakeRow2: IPrivateConnectConnection = {
    privateConnectionName: 'private_connect_test2',
    description: 'It connects to an enpoint service in dev account',
    region: 'us-east-1',
    vpcEndpointId: 'vpce-0510952601a024858',
    serviceName: '       com.amazonaws.vpce.ap-south-1.vpce-svc-090cc9338e1e1159e',
    status: 'Active',
    actions: 'Provision'
  };

  // const actionButtonStyle: React.CSSProperties = {
  //   whiteSpace: 'nowrap', // Prevent buttons from wrapping
  //   textAlign: 'right',
  //   fontSize: '12px',
  //   marginTop: '14px',
  //   marginBottom: '4px',
  //   backgroundColor: '#05628A',
  //   border: '1px solid transparent',
  //   borderRadius: '2px',
  //   boxSizing: 'border-box',
  //   fontWeight: 'bold',
  //   color: '#EAF5FE'
  // };

  let privateConnectConnections: Array<IPrivateConnectConnection> = [];
  privateConnectConnections.push(fakeRow1);
  privateConnectConnections.push(fakeRow2);
  return (
    <SettingsSection title='Private Connections'>
      <div className="tb-user-settings-item-table">
        <table className="tb-static-grid-table">
          <tbody>
          <tr>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                Private Connection Name
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                Description
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text" >
                Region
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text" >
                VPC Endpoint Id
              </span>
            </th>
            {/*<th className={UserSettingsStyle.tableHeaderLine}>*/}
            {/*  <span className="tb-data-grid-header-text" >*/}
            {/*    Service Name*/}
            {/*  </span>*/}
            {/*</th>*/}
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text" >
                Status
              </span>
            </th>
            {/*<th className={UserSettingsStyle.tableHeaderLine}>*/}
            {/*  <span className="tb-data-grid-header-text" >*/}
            {/*    Actions*/}
            {/*  </span>*/}
            {/*</th>*/}
          </tr>
          {privateConnectConnections.map((privateConnectConnection, index) => {
            return (
              <tr key={index} data-tb-test-id='pat-list-item'>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} style={{ margin: '3px 3px' }}>
                      {privateConnectConnection.privateConnectionName}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} style={{ margin: '3px 3px' }}>
                      {privateConnectConnection.description}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} style={{ margin: '3px 3px' }}>
                      {privateConnectConnection.region}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} style={{ margin: '3px 3px' }}>
                      {privateConnectConnection.vpcEndpointId}
                    </span>
                  </div>
                </td>
                {/*<td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>*/}
                {/*  <div className="tb-data-grid-cell-text">*/}
                {/*    <span className={UserSettingsStyle.itemTableName}>*/}
                {/*      {privateConnectConnection.serviceName}*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*</td>*/}
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName} style={{ margin: '6px 3px' }}>
                      {privateConnectConnection.status}
                    </span>
                  </div>
                </td>
                {/*<td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>*/}
                {/*  <div className="tb-data-grid-cell-text">*/}
                {/*    <span className={UserSettingsStyle.itemTableName} style={{ margin: '3px 3px' }}>*/}
                {/*      {privateConnectConnection.actions}*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*</td>*/}
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>

      {/*<ButtonWidget*/}
      {/*  buttonType={ButtonType.LowEmphasis}*/}
      {/*  style={actionButtonStyle}*/}
      {/*  testId={''}>*/}
      {/*  { 'Create New Connection' }*/}
      {/*</ButtonWidget>*/}

    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const PrivateConnectConnectionsSectionSpecs = componentRegistryEntry({
  name: 'PrivateConnectConnectionsSection',
  component: PrivateConnectConnectionsSection
});